import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eol',
  templateUrl: './eol.component.html',
  styleUrls: ['./eol.component.scss']
})
export class EOLComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
